import { SensorConversions } from "../conversionFunctions/sensorConversions.js";
import { SensorElementConfig } from "./types.js";

type SimpleConfig = SensorElementConfig<Record<string, never>, typeof SensorConversions.unity>;

export const inclinationAngleElementConfig: SimpleConfig = {
    legalConvertedRange: [0, 180],
    conversionKey: "unity",
    parameterConfigs: {},
    buildConversionParams: () => ({}),
    decodedUnits: "degree",
    convertedUnits: "degree",
    unitCategory: "dimensionless",
    testCases: [
        { parameters: {}, decodedValue: 0, convertedValue: 0 },
        { parameters: {}, decodedValue: 62.4, convertedValue: 62.4 },
    ],
} as const;

export const inclinationDirectionElementConfig: SimpleConfig = {
    legalConvertedRange: [0, 360],
    conversionKey: "unity",
    parameterConfigs: {},
    buildConversionParams: () => ({}),
    decodedUnits: "degree",
    convertedUnits: "degree",
    unitCategory: "dimensionless",
    testCases: [
        { parameters: {}, decodedValue: 0, convertedValue: 0 },
        { parameters: {}, decodedValue: 346, convertedValue: 346 },
    ],
} as const;
